import { RecipientInfoDto } from 'app/models/api-dto.model';

import { ReportState, ReportType } from '../report/report.service.model';
import { ReportRights } from './dto';

export class ReportDetails {
    name: string;
    description: string;
    icon: string;
    location: string;
    nextPublicationDate: Date;
    reportRights: ReportRights;
    reportType: ReportType;
    shareList: RecipientInfoDto[];
    id: string;
    siteId: string;
    state: ReportState;

    constructor(config: {
        name: string;
        description: string;
        icon: string;
        location: string;
        nextPublicationDate: Date;
        reportRights: ReportRights;
        reportType: ReportType;
        shareList: RecipientInfoDto[];
        id: string;
        siteId: string;
        state: ReportState;
    }) {
        Object.assign(this, config);
    }
}
